import AddressProofError from './AddressProof/AddressProofError';
class AddressProofFileIsMissing extends AddressProofError {
    constructor(options) {
        super('Address Proof file has not been sent', options);
    }
}
export default AddressProofFileIsMissing;
